const icons = {
  SlideTextRightImageLeft: require("./text-right-image-left.svg"),
  SlideTextLeftImageRight: require("./text-left-image-right.svg"),
  SlideImageCompare: require("./image-compare.svg"),
  SlideImage: require("./image.svg"),
  SlideText: require("./text.svg"),
};

export default icons;
